import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, ValidationErrors } from '@angular/forms';

@Directive({
  selector: '[appUintValidate][ngModel]',
  providers: [{ provide: NG_VALIDATORS, useExisting: UintValidateDirective, multi: true }],
})
export class UintValidateDirective {
  @Input('intValidate') validateIndex: string;

  private validationRegex = /^(0|([1-9]\d*))$/;

  validate(control: AbstractControl): ValidationErrors | null {
    const validationKey = 'int_' + this.validateIndex;
    const value = control.value;
    const isValid = value == null || value == '' || this.validationRegex.test(value);

    if (!isValid) {
      return { [validationKey]: true };
    }

    return null;
  }
}
